import React from "react";

const steps = [
  {
    title: "1. Takbir (Opening Takbir)",
    description: `Begin your prayer by raising your hands and saying "Allahu Akbar" (Allah is the Greatest).`,
    image: "/images/takbir.png",
  },
  {
    title: "2. Qiyam (Standing)",
    description: "Stand upright with your hands folded over your chest and recite Surah Al-Fatiha.",
    image: "/images/qiyam.png",
  },
  {
    title: "3. Ruku (Bowing)",
    description: "Bend at the waist with your hands on your knees, keeping your back straight.",
    image: "/images/ruku.png",
  },
  {
    title: "4. Sujud (Prostration)",
    description: "Prostrate by placing your forehead, nose, palms, knees, and toes on the ground.",
    image: "/images/sujud.png",
  },
  {
    title: "5. Tashahhud (Testification)",
    description: "Sit down after the second sujud and recite the Tashahhud.",
    image: "/images/tashahud.png",
  },
  {
    title: "6. Tasleem (Salutation)",
    description:
      'Finish your prayer by turning your head to the right and then to the left while saying "Assalamu Alaikum wa Rahmatullah."',
    image: "/images/tasleem.png",
  },
];

function PrayerStepsPage() {
  return (
    <div className="min-h-screen bg-yellow-50 p-6">
      <h1 className="text-4xl font-extrabold text-center text-blue-700 mb-10 drop-shadow">
        🕌 Steps of Salah (Prayer)
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {steps.map((step, idx) => (
          <div
            key={idx}
            className="bg-white rounded-2xl shadow-xl p-6 text-center border-4 border-yellow-200 hover:shadow-2xl transition"
          >
            <img
              src={step.image}
              alt={step.title}
              className="w-full h-48 object-contain rounded-xl mb-4"
            />
            <h2 className="text-2xl font-bold text-pink-600 mb-2">{step.title}</h2>
            <p className="text-lg text-gray-700">{step.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PrayerStepsPage;
